import { PropsWithChildren, ReactNode, useEffect, useRef } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';

import { getPostHogApiHost } from '@percent/utility';

export function PostHogProvider({ children }: PropsWithChildren): ReactNode {
  const apiKey = process.env.NX_PUBLIC_POSTHOG_API_KEY;
  const initialized = useRef(false);

  useEffect(() => {
    if (!apiKey || initialized.current) return;

    posthog.init(apiKey, {
      api_host: getPostHogApiHost(window.location.hostname),
      ui_host: 'https://eu.posthog.com',
      capture_pageview: false,
      capture_pageleave: false,
      autocapture: false,
      person_profiles: 'identified_only',
      disable_session_recording: true,
    });
    posthog.register({ app: 'grants-nomination-form' });
    initialized.current = true;
  }, [apiKey]);

  if (!apiKey) return children;

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
